import { render, staticRenderFns } from "./Prose.vue?vue&type=template&id=55424340"
import script from "./Prose.vue?vue&type=script&lang=js"
export * from "./Prose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports